const AlarmSettings = () =>
  import('@/views/main/thirdPartyLive/alarmSettings/AlarmSettings.vue')
export default {
  path: '/main/thirdPartyLive/alarmSettings',
  name: 'AlarmSettings',
  component: AlarmSettings
}
